import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles(() => ({
  tablePaper: {
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    borderRadius: 4,
    border: "1px solid #e5e2e5",
    overflow: "hidden"
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    padding: "0 16px",
    borderBottom: "1px solid #e5e2e5",
    backgroundColor: "#f6f6f7"
  },

  prefix: {
    fontFamily: "monospace",
    fontSize: "12px",
    fontWeight: 400,
    color: "#8f8a8f"
  },

  title: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#4b1c46",
    whiteSpace: "nowrap"
  },

  note: {
    padding: "8px 16px",
    fontSize: "12px",
    color: "#8f8a8f"
  },

  tab: {
    textTransform: "none",
    minWidth: 0,
    fontSize: "13px"
  },

  tableContainer: {
    position: "relative",
    maxHeight: 440,
    overflow: "auto"
  },

  loadingOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.6)"
  },

  headCell: {
    backgroundColor: "#f6f6f7",
    color: "#4b1c46",
    fontSize: "12px",
    fontWeight: 500,
    letterSpacing: "0.4px",
    whiteSpace: "nowrap"
  },

  row: {
    "&:hover": {
      backgroundColor: "#fbfafb"
    }
  },

  cell: {
    fontSize: "13px",
    color: "#333"
  },

  idCell: {
    fontSize: "13px",
    color: "#333",
    fontFamily: "monospace"
  },

  failedReason: {
    maxWidth: 360,
    fontSize: "13px",
    color: "#d32f2f",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },

  viewIcon: {
    fontSize: "19px",
    color: "#736973"
  },

  emptyCell: {
    borderBottom: "none",
    padding: "48px 16px"
  },

  emptyText: {
    textAlign: "center",
    fontSize: "14px",
    fontStyle: "italic",
    color: "#8f8a8f"
  },

  pagination: {
    borderTop: "1px solid #e5e2e5",
    flexShrink: 0
  }
}));

export default useStyles;
